import { Skeleton, SkeletonAvatar, SkeletonText } from '../../../components/Skeleton';
import styles from './ProfileSkeleton.module.scss';

export interface ProfileSkeletonProps {
  className?: string;
}

export function ProfileSkeleton({ className }: ProfileSkeletonProps) {
  const classes = [styles.profileSkeleton, className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {/* Header section mirroring the banner */}
      <div className={styles.header}>
        <div className={styles.avatarWrapper}>
          {/* Large avatar */}
          <SkeletonAvatar size="80px" className={styles.avatar} />

          {/* Username + status + buttons */}
          <div className={styles.userInfo}>
            <SkeletonText lines={1} lineHeight="2rem" lastLineWidth="160px" className={styles.username} />
            <SkeletonText lines={1} lineHeight="1rem" lastLineWidth="60px" className={styles.status} />
            <div className={styles.buttonGroup}>
              <Skeleton width="6rem" height="2.25rem" borderRadius="999px" />
              <Skeleton width="6rem" height="2.25rem" borderRadius="999px" />
            </div>
          </div>

          {/* Platform badge placeholders */}
          <div className={styles.badgeGrid}>
            <Skeleton width="42px" height="42px" borderRadius="50%" />
            <Skeleton width="42px" height="42px" borderRadius="50%" />
            <Skeleton width="42px" height="42px" borderRadius="50%" />
          </div>
        </div>
      </div>

      {/* Follower/Following counts */}
      <div className={styles.followSection}>
        <Skeleton width="100px" height="1rem" borderRadius="4px" />
        <Skeleton width="10px" height="1rem" borderRadius="4px" />
        <Skeleton width="100px" height="1rem" borderRadius="4px" />
      </div>

      {/* Tab bar */}
      <div className={styles.tabBar}>
        <Skeleton width="70px" height="1rem" borderRadius="4px" />
        <Skeleton width="50px" height="1rem" borderRadius="4px" />
        <Skeleton width="60px" height="1rem" borderRadius="4px" />
        <Skeleton width="100px" height="1rem" borderRadius="4px" />
        <Skeleton width="100px" height="1rem" borderRadius="4px" />
      </div>
    </div>
  );
}

export default ProfileSkeleton;
